/*
 * From http://www.redblobgames.com/
 * Copyright 2018 Red Blob Games <redblobgames@gmail.com>
 * License: Apache v2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>
 */
'use strict';

/* global Draggable, Vue */


/* Implementation note:

   Vue's update() only gets called if the DOM element is changed.
   For the canvas element, the watch and draw properties aren't
   part of the DOM element so they need watch{} instead of update().
*/
    


/** Canvas component

   A generic canvas component that calls a draw function to draw the
   contents, and automatically calls it again when anything the draw
   function depends on changes.

   Example:

   <a-canvas width="500" height="200"
             :draw="(canvas, ctx) => { ctx.fillRect(x,y,1,1); }" />

   This will call the draw function when the canvas is created,
   and also update it whenever x or y changes, because the draw
   function depends on them. Typical use: pass in a method from the
   parent component.

   Note:

   This function will clear the canvas contents before calling the
   draw function. It will wrap the call in save()/restore() to reset
   the drawing state back to the default.

   The canvas will fit the container. TODO: figure out a better default.

   If useDevicePixelRatio is set, it will rescale the canvas based on
   window.devicePixelRatio. (TODO: this value can change over time and
   there is no event, so use setInterval to check it periodically and
   call redraw when it changes)
*/
Vue.component('a-canvas', {
    props: ['width', 'height', 'draw', 'useDevicePixelRatio'],
    data() { return { canvas: null, }; },
    template: `<canvas style="width:100%;height:auto"
                       :data-automatic="canvas &amp;&amp; redraw">`,
    mounted() { this.canvas = this.$el; },
    computed: {
        redraw() {
            let canvas = this.canvas;
            let ratio = this.useDevicePixelRatio? window.devicePixelRatio : 1;
            canvas.width = this.width * ratio;
            canvas.height = this.height * ratio;
            let ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.save();
            ctx.scale(ratio, ratio);
            this.draw(canvas, ctx);
            ctx.restore();
        },
    },
});
/* Implementation note: I set data-automatic="canvas && redraw" to make
   the DOM depend on this computed property. The first time it's calculated,
   the canvas doesn't exist yet. Subsequent calculations invoke the computed
   property "redraw", which calls the draw function, which sets up the automatic
   dependency tracking in Vue. This redraw function also uses the
   width, height, and draw properties, so if any of those change, it
   will trigger a redraw. */
              

/* Generic wrapper around my draggable.v2.js library to handle mouse drags */
Vue.directive('draggable', {
    bind(el, binding) {
        const props = binding.value;
        el.__draggable__ = new Draggable({
            el: el,
            start(event) { props.start && props.start(this, event); },
            drag(event) { props.drag && props.drag(this, event); },
            end(event) { props.end && props.end(this, event); },
        });
    },
    unbind(el, binding) {
        el.__draggable__.uninstall();
        delete el.__draggable__;
    }
});
